/**
 * Add products from bundle to cart
 */
class BuyBundle extends HTMLElement {
  /**
   * connectedCallback
   */
  connectedCallback() {
    this.button = this.querySelector('button');
    this.button.addEventListener('click', () => {
      const items = this.getAttribute('data-prod-ids')
        .split(',')
        .map((item) => {
          return {
            id: item,
            quantity: 1,
          };
        });

      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      // eslint-disable-next-line
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData();
      if (this.cart) {
        formData.append(
          'sections',
          this.cart.getSectionsToRender().map((section) => section.id)
        );
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }

      items.forEach((product, index) => {
        formData.append(`items[${index}][id]`, product.id);
        formData.append(`items[${index}][quantity]`, product.quantity);
      });

      config.body = formData;

      fetch('/cart/add.js', config)
        .then((response) => response.json())
        .then((response) => {
          document.dispatchEvent(
            new CustomEvent('cart:itemsAdded', {
              detail: {
                items: response.items,
                source: 'bundle',
              },
            })
          );
          window.lastAddedItems = response.items;
          window.lastAddedSource = 'bundle';
          response.items[0].sections = response.sections;
          document.querySelector('cart-drawer').classList.remove('is-empty');
          // eslint-disable-next-line
          CartPerformance.measure('add:paint-updated-sections', () => {
            this.cart.renderContents(response.items[0]);
          });
        })
        .catch((error) => console.error('Error:', error));
    });
  }
}
customElements.define('buy-bundle', BuyBundle);
